import Alert from '@mui/material/Alert'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'
import React from 'react'

import T from 'T'
import { isValidLatitudeRange, isValidLongitudeRange } from 'utils/validations'

const DragPinMessage = ({ latitude = '', longitude = '', sx = {} }) => {
  const isValidLatLong = isValidLatitudeRange(latitude) && isValidLongitudeRange(longitude)

  return (
    isValidLatLong && (
      <Grid size={12}>
        <Alert severity="info" sx={{ display: 'flex', alignItems: 'center', ...sx }}>
          {/* The theme shrinks body2 (the Alert default) to 11px — use body1 so the message stays readable */}
          <Typography variant="body1">{T.DRAG_PIN_MESSAGE}</Typography>
        </Alert>
      </Grid>
    )
  )
}

DragPinMessage.propTypes = {
  latitude: PropTypes.string,
  longitude: PropTypes.string,
  sx: PropTypes.object,
}

export default DragPinMessage
